import {
  ColumnHeaderMultiSelectFilter,
  UpdateFilterType,
} from "../../ReusableHeaderFilter/ColumnHeaderMultiSelectFilter";
import React from "react";
import { Task1120TrackerFilterType } from "../Task1120TrackerFilter";
import { useGetServiceTeamQuery } from "store/apis/serviceTeam";
import {
  FILTER_SERVICE_TEAM_MEMBER,
  UNASSIGNED_OPTION,
} from "../Task1120FilterOptions";
import { useRoleBasedView } from "hooks/useRoleBasedView";
import { validate } from "uuid";

export const ServiceTeamMemberColumnHeader = ({
  values,
  updateFilter,
  defaultServiceTeamId,
}: Omit<Task1120TrackerFilterType, "updateFilter"> & {
  updateFilter: UpdateFilterType;
  defaultServiceTeamId: string | null;
}) => {
  const selectedTeams = values.SERVICE_TEAM || null;
  const { isAdmin } = useRoleBasedView();
  const serviceTeamIds = (isAdmin ? selectedTeams : defaultServiceTeamId)
    ?.split(",")
    .filter((id) => validate(id))
    .join(",");
  const { data: teamMembers = [] } = useGetServiceTeamQuery(
    { serviceTeamId: serviceTeamIds },
    {
      skip: !serviceTeamIds,
      refetchOnMountOrArgChange: true,
    }
  );

  const updatedOptions = [
    { uuid: UNASSIGNED_OPTION, name: "Unassigned" },
    ...teamMembers,
  ];

  return (
    <div className="t-flex t-items-center t-justify-between t-w-full">
      <div>Tax Preparer</div>
      <ColumnHeaderMultiSelectFilter
        filterName={FILTER_SERVICE_TEAM_MEMBER}
        options={updatedOptions.map((member) => ({
          value: member.uuid,
          label: member.name,
        }))}
        selected={values.SERVICE_TEAM_MEMBER || null}
        updateFilter={updateFilter}
      />
    </div>
  );
};
